/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, FormControl, FormControlLabel, IconButton, makeStyles, Radio, RadioGroup, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
import { ChartFilter } from '../ChartComponents';
import CloseIcon from '@material-ui/icons/Close';
import { convertStringNumberToNumber, formatNumber, getMaxSuggestedTick, getHighestNumberInArray } from '../../helpers/ChartHelper';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { DrillDownType } from '../DrillDownType';
import { SearchCriteria } from '../SearchCriteria';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import { useScreenshot, createFileName } from 'use-react-screenshot';
import MTooltip from '@material-ui/core/Tooltip';
import { ChartInfo } from '../../components/ChartInfo';
import VideoLibraryOutlinedIcon from '@material-ui/icons/VideoLibraryOutlined';
import { VideoModal } from '../../components/VideoModal';
import { AIChartDialog } from '../../components/Dialogs/AIChartDialog';
import html2canvas from 'html2canvas';
import { AIIcon } from '../../components/icons/AIIcon';

import { RV_CHART_CLASS, RV_CHART_COLORS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvLegendLabels, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { ChartLimitNote } from '../ChartLimitNote';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartStatTiles } from '../ChartStatTiles';
import { ChartEmptyState } from '../ChartEmptyState';
import InsertChartOutlinedIcon from '@material-ui/icons/InsertChartOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px 0px 15px',
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '300px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
            '&:hover': {
                '& .scroll': {
                    display: 'flex !important',
                    '& .Mui-disabled': {
                        '& .MuiSvgIcon-root': {
                            color: 'inherit !important',
                        },
                    },
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            position: 'relative',
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
        footerDescription: {
            fontSize: '1rem',
            textAlign: 'center',
        },
        learnIcon: {
            color: 'rgb(0, 120, 212)'
        },
        scrollUp: {
            display: 'none',
            position: 'absolute',
            top: '30px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        scrollDown: {
            display: 'none',
            position: 'absolute',
            bottom: '90px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
    }),
);

enum DateRangeSelectionEnum {
    LAST_7_DAYS = 0,
    LAST_30_DAYS,
    LAST_90_DAYS,
    LAST_12_MONTHS,
    MONTH_TO_DATE,
    PREV_MONTH,
    YEAR_TO_DATE,
}

interface CombinedNewLeadsByCategoryChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
    selectedOption?: DateRangeSelectionEnum;
    infoUrl: string | null;
}

interface ChartState {
    options: DateRangeSelectionEnum;
    groupedBy: string[];
    lastCount: number[];
    lastEstimate: number[];
    previousCount: number[];
    previousEstimate: number[];
    matterOpenCount: number;
    matterOpenEstimate: number;
    matterOpenWithoutEstimate: number;
    prevmatterOpenCount: number;
    prevmatterOpenEstimate: number;
    prevmatterOpenWithoutEstimate: number;
    groupedByCountValue: number;
    symbol: string;
}

export const CombinedNewLeadsByCategoryChart: React.FC<CombinedNewLeadsByCategoryChartProps> = (props) => {
    const classes = useStyles();

    const chartName = 'New Leads By Category';

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const entireChartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollUpAndPrevRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollDownAndNextRef = React.useRef<any>();

    const [isVideoModalOpen, setIsVideoModalOpen] = useState<boolean>(false);

    const [base64Data, setBase64Data] = useState<string | ArrayBuffer | null>(null);
    
    const [isAIDialogOpen, setIsAIDialogOpen] = useState<boolean>(false);

    const [isBlobGenerating, setIsBlobGenerating] = useState<boolean>(false);

    const takeScreenShot = useScreenshot({
        type: 'image/jpeg',
        quality: 1.0,
    })[1];

    const [state, setState] = useState<ChartState>({
        options: props.maximizeSelected ? props.maximizeSelected.options : DateRangeSelectionEnum.MONTH_TO_DATE,
        groupedBy: [],
        lastCount: [],
        lastEstimate : [],
        previousCount : [],
        previousEstimate : [],
        matterOpenCount : 0,
        matterOpenEstimate : 0,
        matterOpenWithoutEstimate : 0,
        prevmatterOpenCount : 0,
        prevmatterOpenEstimate : 0,
        prevmatterOpenWithoutEstimate : 0,
        groupedByCountValue: 0,
        symbol: '$'
    });

    React.useEffect(() => {
        window.addEventListener('keydown', onKeyDownHandler);

        return () => {
            window.removeEventListener('keydown', onKeyDownHandler);
        };
        // tslint:disable-next-line: align
    }, []);

    // tslint:disable-next-line: no-any
    const onKeyDownHandler = (event: any) => {
        if (event.keyCode === 80 && (event.ctrlKey || event.metaKey) && !event.altKey) {
            event.preventDefault();
            if (event.stopImmediatePropagation) {
                event.stopImmediatePropagation();
            } else {
                event.stopPropagation();
            }
            return;
        }
    };

    // tslint:disable-next-line:no-any
    const closedMattersByFeeEarnerQuery = useQuery<CombinedNewLeadsData, CombineNewLeadsDataVariables>(COMBINED_NEW_LEADS_DATA, {
        variables: {
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            responsibility: props.chartFilter?.responsibility,
        },
        fetchPolicy: 'cache-and-network',
    });

    const currencySymbolQuery = useQuery<CurrencySymbolData>(CURRENCY_SYMBOL_QUERY);

    useEffect(() => {
        if (currencySymbolQuery.data && currencySymbolQuery.data.options && !currencySymbolQuery.loading && !currencySymbolQuery.error) {
            setState((prevState) => {
                return {
                    ...prevState,
                    symbol: currencySymbolQuery.data!.options.currencySymbol.symbol,
                };
            });
        }
        // tslint:disable-next-line: align
    }, [currencySymbolQuery.loading, currencySymbolQuery.error, currencySymbolQuery.data]);

    useEffect(() => {
        if (
            !closedMattersByFeeEarnerQuery.loading &&
            !closedMattersByFeeEarnerQuery.error &&
            closedMattersByFeeEarnerQuery &&
            closedMattersByFeeEarnerQuery.data &&
            closedMattersByFeeEarnerQuery.data.statistics &&
            closedMattersByFeeEarnerQuery.data.statistics.matter &&
            closedMattersByFeeEarnerQuery.data.statistics.matter.combinedNewMatterLeadsByCategory
        ) {
            setState((prevState) => {
                let groupedBy: string[] = [];
                let lastCount: number[] = [];
                let lastEstimate: number[] = [];
                let previousCount: number[] = [];
                let previousEstimate: number[] = [];

                let matterOpenCount: number = 0;
                let matterOpenEstimate: number = 0;
                let matterOpenWithoutEstimate: number = 0;

                let prevmatterOpenCount: number = 0;
                let prevmatterOpenEstimate: number = 0;
                let prevmatterOpenWithoutEstimate: number = 0;
                let groupedByCountValue: number = 0;

                var {
                    combinedNewMatterLeadsByCategoryLast7Days,
                    combinedNewMatterLeadsByCategoryLast30Days,
                    combinedNewMatterLeadsByCategoryLast90Days,
                    combinedNewMatterLeadsByCategoryLast12Months,
                    combinedNewMatterLeadsByCategoryMonthToDate,
                    combinedNewMatterLeadsByCategoryPreviousMonth,
                    combinedNewMatterLeadsByCategoryYearToDate,
                } = closedMattersByFeeEarnerQuery.data!.statistics.matter.combinedNewMatterLeadsByCategory;

                if (state.options === DateRangeSelectionEnum.LAST_7_DAYS) {
                    const { combinedNewMatterLeads, matterLeadsOpenedCountTotal, previousYearMatterLeadsOpenedCountTotal, groupedByCount } = combinedNewMatterLeadsByCategoryLast7Days;
                    groupedBy = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.groupedBy);
                    lastCount = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.lastCount);
                    lastEstimate = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.lastEstimate);
                    previousCount = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.previousCount);
                    previousEstimate = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.previousEstimate);

                    matterOpenCount = matterLeadsOpenedCountTotal.count;
                    matterOpenEstimate = matterLeadsOpenedCountTotal.totalEstimates;
                    matterOpenWithoutEstimate = matterLeadsOpenedCountTotal.mattersWithoutEstimate;

                    prevmatterOpenCount = previousYearMatterLeadsOpenedCountTotal.count;
                    prevmatterOpenEstimate = previousYearMatterLeadsOpenedCountTotal.totalEstimates;
                    prevmatterOpenWithoutEstimate = previousYearMatterLeadsOpenedCountTotal.mattersWithoutEstimate;

                    groupedByCountValue = groupedByCount;
                } else if (state.options === DateRangeSelectionEnum.LAST_30_DAYS) {
                    const { combinedNewMatterLeads, matterLeadsOpenedCountTotal, previousYearMatterLeadsOpenedCountTotal, groupedByCount } = combinedNewMatterLeadsByCategoryLast30Days;
                    groupedBy = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.groupedBy);
                    lastCount = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.lastCount);
                    lastEstimate = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.lastEstimate);
                    previousCount = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.previousCount);
                    previousEstimate = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.previousEstimate);

                    matterOpenCount = matterLeadsOpenedCountTotal.count;
                    matterOpenEstimate = matterLeadsOpenedCountTotal.totalEstimates;
                    matterOpenWithoutEstimate = matterLeadsOpenedCountTotal.mattersWithoutEstimate;
                    prevmatterOpenCount = previousYearMatterLeadsOpenedCountTotal.count;
                    prevmatterOpenEstimate = previousYearMatterLeadsOpenedCountTotal.totalEstimates;
                    prevmatterOpenWithoutEstimate = previousYearMatterLeadsOpenedCountTotal.mattersWithoutEstimate;

                    groupedByCountValue = groupedByCount;
                } else if (state.options === DateRangeSelectionEnum.LAST_90_DAYS) {
                    const { combinedNewMatterLeads, matterLeadsOpenedCountTotal, previousYearMatterLeadsOpenedCountTotal, groupedByCount } = combinedNewMatterLeadsByCategoryLast90Days;
                    groupedBy = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.groupedBy);
                    lastCount = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.lastCount);
                    lastEstimate = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.lastEstimate);
                    previousCount = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.previousCount);
                    previousEstimate = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.previousEstimate);

                    matterOpenCount = matterLeadsOpenedCountTotal.count;
                    matterOpenEstimate = matterLeadsOpenedCountTotal.totalEstimates;
                    matterOpenWithoutEstimate = matterLeadsOpenedCountTotal.mattersWithoutEstimate;
                    prevmatterOpenCount = previousYearMatterLeadsOpenedCountTotal.count;
                    prevmatterOpenEstimate = previousYearMatterLeadsOpenedCountTotal.totalEstimates;
                    prevmatterOpenWithoutEstimate = previousYearMatterLeadsOpenedCountTotal.mattersWithoutEstimate;

                    groupedByCountValue = groupedByCount;
                } else if (state.options === DateRangeSelectionEnum.LAST_12_MONTHS) {
                    const { combinedNewMatterLeads, matterLeadsOpenedCountTotal, previousYearMatterLeadsOpenedCountTotal, groupedByCount } = combinedNewMatterLeadsByCategoryLast12Months;
                    groupedBy = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.groupedBy);
                    lastCount = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.lastCount);
                    lastEstimate = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.lastEstimate);
                    previousCount = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.previousCount);
                    previousEstimate = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.previousEstimate);

                    matterOpenCount = matterLeadsOpenedCountTotal.count;
                    matterOpenEstimate = matterLeadsOpenedCountTotal.totalEstimates;
                    matterOpenWithoutEstimate = matterLeadsOpenedCountTotal.mattersWithoutEstimate;
                    prevmatterOpenCount = previousYearMatterLeadsOpenedCountTotal.count;
                    prevmatterOpenEstimate = previousYearMatterLeadsOpenedCountTotal.totalEstimates;
                    prevmatterOpenWithoutEstimate = previousYearMatterLeadsOpenedCountTotal.mattersWithoutEstimate;

                    groupedByCountValue = groupedByCount;
                } else if (state.options === DateRangeSelectionEnum.MONTH_TO_DATE) {
                    const { combinedNewMatterLeads, matterLeadsOpenedCountTotal, previousYearMatterLeadsOpenedCountTotal, groupedByCount } = combinedNewMatterLeadsByCategoryMonthToDate;
                    groupedBy = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.groupedBy);
                    lastCount = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.lastCount);
                    lastEstimate = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.lastEstimate);
                    previousCount = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.previousCount);
                    previousEstimate = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.previousEstimate);

                    matterOpenCount = matterLeadsOpenedCountTotal.count;
                    matterOpenEstimate = matterLeadsOpenedCountTotal.totalEstimates;
                    matterOpenWithoutEstimate = matterLeadsOpenedCountTotal.mattersWithoutEstimate;
                    prevmatterOpenCount = previousYearMatterLeadsOpenedCountTotal.count;
                    prevmatterOpenEstimate = previousYearMatterLeadsOpenedCountTotal.totalEstimates;
                    prevmatterOpenWithoutEstimate = previousYearMatterLeadsOpenedCountTotal.mattersWithoutEstimate;

                    groupedByCountValue = groupedByCount;
                } else if (state.options === DateRangeSelectionEnum.PREV_MONTH) {
                    const { combinedNewMatterLeads, matterLeadsOpenedCountTotal, previousYearMatterLeadsOpenedCountTotal, groupedByCount } = combinedNewMatterLeadsByCategoryPreviousMonth;
                    groupedBy = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.groupedBy);
                    lastCount = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.lastCount);
                    lastEstimate = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.lastEstimate);
                    previousCount = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.previousCount);
                    previousEstimate = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.previousEstimate);

                    matterOpenCount = matterLeadsOpenedCountTotal.count;
                    matterOpenEstimate = matterLeadsOpenedCountTotal.totalEstimates;
                    matterOpenWithoutEstimate = matterLeadsOpenedCountTotal.mattersWithoutEstimate;
                    prevmatterOpenCount = previousYearMatterLeadsOpenedCountTotal.count;
                    prevmatterOpenEstimate = previousYearMatterLeadsOpenedCountTotal.totalEstimates;
                    prevmatterOpenWithoutEstimate = previousYearMatterLeadsOpenedCountTotal.mattersWithoutEstimate;

                    groupedByCountValue = groupedByCount;
                } else {
                    const { combinedNewMatterLeads, matterLeadsOpenedCountTotal, previousYearMatterLeadsOpenedCountTotal, groupedByCount } = combinedNewMatterLeadsByCategoryYearToDate;
                    groupedBy = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.groupedBy);
                    lastCount = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.lastCount);
                    lastEstimate = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.lastEstimate);
                    previousCount = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.previousCount);
                    previousEstimate = combinedNewMatterLeads.map((combinedMatters) => combinedMatters.previousEstimate);
                    matterOpenCount = matterLeadsOpenedCountTotal.count;
                    matterOpenEstimate = matterLeadsOpenedCountTotal.totalEstimates;
                    matterOpenWithoutEstimate = matterLeadsOpenedCountTotal.mattersWithoutEstimate;

                    prevmatterOpenCount = previousYearMatterLeadsOpenedCountTotal.count;
                    prevmatterOpenEstimate = previousYearMatterLeadsOpenedCountTotal.totalEstimates;
                    prevmatterOpenWithoutEstimate = previousYearMatterLeadsOpenedCountTotal.mattersWithoutEstimate;

                    groupedByCountValue = groupedByCount;
                } 
                return {
                    ...prevState,
                    groupedBy,
                    lastCount,
                    lastEstimate,
                    previousCount,
                    previousEstimate,
                    matterOpenCount,
                    matterOpenEstimate,
                    matterOpenWithoutEstimate,
                    prevmatterOpenCount,
                    prevmatterOpenEstimate,
                    prevmatterOpenWithoutEstimate,
                    groupedByCountValue
                };
            });
        }
        // tslint:disable-next-line: align
    }, [state.options, closedMattersByFeeEarnerQuery.loading, closedMattersByFeeEarnerQuery.error, closedMattersByFeeEarnerQuery.data]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            props.onCloseChart(`isCombinedNewLeadsByCategoryChartByCategoryOpen`);
        }
    };

    const GetDateRangeSelectiondLabel = (dateRangeEnum: DateRangeSelectionEnum) => {
        switch (dateRangeEnum) {
            case DateRangeSelectionEnum.LAST_7_DAYS:
                return 'Last 7 Days';
            case DateRangeSelectionEnum.LAST_30_DAYS:
                return 'Last 30 Days';
            case DateRangeSelectionEnum.LAST_90_DAYS:
                return 'last 90 Days';
            case DateRangeSelectionEnum.LAST_12_MONTHS:
                return 'Last 12 Months';
            case DateRangeSelectionEnum.MONTH_TO_DATE:
                return 'Month To Date';
            case DateRangeSelectionEnum.PREV_MONTH:
                return 'Previous Month';
            case DateRangeSelectionEnum.YEAR_TO_DATE:
                return 'Financial Year to Date';
            default:
                return '';
        }
    };

    const handleTotalClick = () => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();

            if (state.options === DateRangeSelectionEnum.LAST_7_DAYS) {
                searchCriterias.push({ property: 'SevenDays', operator: 'entered', comparison: 'curr' });
            } else if (state.options === DateRangeSelectionEnum.LAST_30_DAYS) {
                searchCriterias.push({ property: 'ThirtyDays', operator: 'entered', comparison: 'curr' });
            } else if (state.options === DateRangeSelectionEnum.LAST_90_DAYS) {
                searchCriterias.push({ property: 'NinetyDays', operator: 'entered', comparison: 'curr' });
            } else if (state.options === DateRangeSelectionEnum.LAST_12_MONTHS) {
                searchCriterias.push({ property: '12MonthPeriod', operator: 'entered', comparison: 'curr' });
            } else if (state.options === DateRangeSelectionEnum.MONTH_TO_DATE) {
                searchCriterias.push({ property: 'ThisMonth', operator: 'instruction', comparison: 'curr' });
            } else if (state.options === DateRangeSelectionEnum.PREV_MONTH) {
                searchCriterias.push({ property: 'ThisMonth', operator: 'instruction', comparison: 'prev' });
            } else {
                searchCriterias.push({ property: 'YearToDate', operator: 'instruction', comparison: 'curr' });
            }
            
            props.getSelectedItem(
                searchCriterias, 
                true, 
                `New Leads by Category for ${GetDateRangeSelectiondLabel(state.options)}`, 
                DrillDownType.matterSummaryDrilldown, 
                'New Matter Details',
                undefined,
                undefined,
                undefined,
                undefined,
                true
            );
        }
    };

    const onChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
        setState((prevState) => {
            return {
                ...prevState,
                // tslint:disable-next-line: radix
                options: parseInt((event.target as HTMLInputElement).value),
            };
        });
    };

    const onScrollUpAndPrev = (type: 'up' | 'prev') => {
        if (chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min > 0) {
            const scrollRatio = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            const min = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            if (scrollRatio < chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min) {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= scrollRatio ? scrollRatio : 1;
            } else {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= min;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= min;
            }
            chartRef.current.options.scales[type === 'up' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll up
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll up
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }
        scrollDownAndNextRef.current.classList.remove('Mui-disabled');
    };

    const onScrollDownAndNext = (type: 'down' | 'next') => {
        const labels = state.groupedBy;

        if (chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max < labels.length) {
            const remainingBar = labels.length - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max;
            const scrollRatio = chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min;
            if (remainingBar <= scrollRatio) {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += remainingBar;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += remainingBar;
            } else {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += scrollRatio ? scrollRatio : 1;
            }
            chartRef.current.options.scales[type === 'down' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll down
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll down
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
        scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
    };

    const onScollBar = (type: 'up' | 'down' | 'prev' | 'next') => () => {
        if (type === 'up') {
            onScrollUpAndPrev('up');
        } else if (type === 'down') {
            onScrollDownAndNext('down');
        } else if (type === 'next') {
            onScrollDownAndNext('next');
        } else {
            onScrollUpAndPrev('prev');
        }
    };

    const onDisabledEnabledArrow = (barType: 'horizontal' | 'vertical') => {
        const labels = state.lastCount;
        // up
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].min > 0) {
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }

        // down
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].max < labels.length) {
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
    };

    const onPan = (context: { chart: Chart }) => {
        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };

    const onZoom = (context: { chart: Chart }) => {
        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    const onMaximize = () => {
        if (props.onMaximizeSelected) {
            props.onMaximizeSelected({
                options: state.options,
            });
        }
    };

    const onToggleVideo = () => {
        setIsVideoModalOpen(!isVideoModalOpen);
    };

    // tslint:disable-next-line: no-any
    const onContextMenu = (event: any) => {
        event.preventDefault();
        if (event.button !== 2) {
            return false;
        }
        return true;
    };

    // tslint:disable-next-line: no-any
    const onDownload =
        (name: string, extension: string = 'jpg') =>
        // tslint:disable-next-line: no-any
        (image: any) => {
            const a = document.createElement('a');
            a.href = image;
            a.download = createFileName(extension, name);
            a.click();
        };

    // tslint:disable-next-line: no-any
    const onDownloadScreenshot = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        setTimeout(() => {
            takeScreenShot(entireChartRef.current).then(onDownload(`New Leads by Category Chart`));
            // tslint:disable-next-line: align
        }, 500);
    };

    const onAIGeneratedSuggestion = async (event: any) => {

        setIsBlobGenerating(true);

        event.preventDefault();
        event.stopPropagation();
       
        if (entireChartRef && entireChartRef.current) {
            const canvas = await html2canvas(entireChartRef.current);
            canvas.toBlob((blob) => {
                if (blob) {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = async () => {
                        const tempBase64data = reader.result;
                        // console.log(tempBase64data); // This is your image blob string
                        setBase64Data(tempBase64data);
                        setIsAIDialogOpen(true);
                    };
                }
            });
        }

        setIsBlobGenerating(false);
    };

    const chartControlComponent = () => {
        return (
            <>
                <IconButtonWrapper aria-label="close">
                    <div
                        className={`${classes.helpIcon} rv-chart-help`} 
                    >
                        <ChartInfo 
                            description={props.description}
                            fontSize={props.showAllRecords ? 'large' : 'medium'}
                            // className={classes.helpIcon}
                        />
                        {props.infoUrl && (
                            <MTooltip title="Learn more">
                                <IconButton className={classes.learnIcon} aria-label="maximize" onClick={onToggleVideo} size={props.showAllRecords ? 'medium' : 'small'}>
                                    <VideoLibraryOutlinedIcon />
                                </IconButton>
                            </MTooltip>
                        )}
                    </div>
                    {props.isAIFeatureEnabled && (
                        <MTooltip title="AI Assistant">
                            <IconButton 
                                disabled={isBlobGenerating}
                                size={props.showAllRecords ? 'medium' : 'small'}
                                onClick={onAIGeneratedSuggestion}
                            >
                                <AIIcon 
                                    color="primary"
                                    fontSize={props.showAllRecords ? 'large' : 'medium'}
                                />
                            </IconButton>
                        </MTooltip>
                    )}
                    {props.showAllRecords && (
                        <IconButton size="medium" onClick={onDownloadScreenshot}>
                            <GetAppOutlinedIcon color="primary" fontSize="large" />
                        </IconButton>
                    )}
                    {!props.showAllRecords && props.onMaximizeSelected && (
                        <MTooltip title="Expand chart">
                            <IconButton aria-label="maximize" onClick={onMaximize} size="small">
                                <AspectRatioIcon />
                            </IconButton>
                        </MTooltip>
                    )}
                    <IconButton aria-label="close" onClick={onCloseChart} size={props.showAllRecords ? 'medium' : 'small'}>
                        <CloseIcon className={classes.closeIcon} fontSize={props.showAllRecords ? 'large' : 'medium'} />
                    </IconButton>
                </IconButtonWrapper>
            </>
        );
    };

    if (closedMattersByFeeEarnerQuery.loading) {
        return (
            <div className="rv-chart rv-chart-loading">
                {chartControlComponent()}
                <ChartSkeleton variant="bars" />
            </div>
        );
    }

    return (
        <>
            {isAIDialogOpen && (
                <AIChartDialog 
                    fullWidth={true}
                    maxWidth="md"
                    open={isAIDialogOpen}
                    onClose={() => setIsAIDialogOpen(false)}
                    data={base64Data}
                    query={props.aiPrompt || 'Give me recommendations on this and highlight any exceptions or concerns'}
                    accessSubType={chartName}
                    layoutId={props.layoutId}
                />
            )}
            <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(state.lastCount, state.previousCount) ? ' rv-chart--empty' : ''}`} ref={entireChartRef}>
                {isVideoModalOpen && props.infoUrl && (
                    <VideoModal 
                        open={isVideoModalOpen}
                        onClose={onToggleVideo}
                        url={props.infoUrl}
                    />
                )}
                {chartControlComponent()}
                <div className={classes.titleContainer}>
                    <ChartHeading icon={<InsertChartOutlinedIcon />} title={chartName} />
                    <div className={`${classes.total} h2`} onClick={handleTotalClick}>
                        <AnimatedNumber value={state.matterOpenCount} format={(amount) => `${Math.round(amount)}`} />
                    </div>
                    <div className={classes.title}>{GetDateRangeSelectiondLabel(state.options)}</div>
                    <ChartStatTiles
                        tiles={[
                            { label: 'Total fees', value: `${state.symbol}${formatNumber(state.matterOpenEstimate)}`, color: RV_CHART_COLORS.green },
                            { label: 'Leads without estimates', value: formatNumber(state.matterOpenWithoutEstimate), color: RV_CHART_COLORS.amber },
                        ]}
                    />
                </div>
                <div className={classes.barContainer} style={{ maxHeight: props.showAllRecords ? '100%' : '350px' }}>
                    {props.showAllRecords && (
                        <>
                            <div className={`${classes.scrollUp} scroll`}>
                                <IconButton size="medium" onClick={onScollBar('up')} ref={scrollUpAndPrevRef}>
                                    <KeyboardArrowUpIcon color="primary" fontSize="large" />
                                </IconButton>
                            </div>
                            <div className={`${classes.scrollDown} scroll`}>
                                <IconButton size="medium" onClick={onScollBar('down')} ref={scrollDownAndNextRef}>
                                    <KeyboardArrowDownIcon color="primary" fontSize="large" />
                                </IconButton>
                            </div>
                        </>
                    )}
                    <Bar
                        ref={chartRef}
                        onContextMenu={onContextMenu}
                        // tslint:disable-next-line: no-any
                        onClick={(event: React.MouseEvent<any>) => {
                            const _data = getElementAtEvent(chartRef.current, event);
                            if (_data.length > 0 && props.getSelectedItem) {
                                const _index = getElementAtEvent(chartRef.current, event)[0].index;
                                const _datasetIndex = getElementAtEvent(chartRef.current, event)[0].datasetIndex;

                                const item = state.groupedBy[_index];

                                const grouping = state.groupedBy[_index];

                                const searchCriterias = new Array<SearchCriteria>();

                                if (state.options === DateRangeSelectionEnum.LAST_7_DAYS) {
                                    searchCriterias.push(
                                        { property: 'Category', operator: 'eq', comparison: grouping },
                                        { property: 'SevenDays', operator: 'eq', comparison: _datasetIndex === 1 ? 'prev' : 'curr' },
                                    );
                                } else if (state.options === DateRangeSelectionEnum.LAST_30_DAYS) {
                                    searchCriterias.push(
                                        { property: 'Category', operator: 'eq', comparison: grouping },
                                        { property: 'ThirtyDays', operator: 'eq', comparison: _datasetIndex === 1 ? 'prev' : 'curr' },
                                    );
                                } else if (state.options === DateRangeSelectionEnum.LAST_90_DAYS) {
                                    searchCriterias.push(
                                        { property: 'Category', operator: 'eq', comparison: grouping },
                                        { property: 'NinetyDays', operator: 'eq', comparison: _datasetIndex === 1 ? 'prev' : 'curr' },
                                    );
                                } else if (state.options === DateRangeSelectionEnum.LAST_12_MONTHS) {
                                    searchCriterias.push(
                                        { property: 'Category', operator: 'eq', comparison: grouping },
                                        { property: '12MonthPeriod', operator: 'instruction', comparison: _datasetIndex === 1 ? 'prev' : 'curr' },
                                    );
                                } else if (state.options === DateRangeSelectionEnum.PREV_MONTH) {
                                    searchCriterias.push(
                                        { property: 'Category', operator: 'eq', comparison: grouping },
                                        { property: 'ThisMonth', operator: 'instruction', comparison: _datasetIndex === 1 ? 'prevprev' : 'prev' },
                                    );
                                } else if (state.options === DateRangeSelectionEnum.MONTH_TO_DATE) {
                                    searchCriterias.push(
                                        { property: 'Category', operator: 'eq', comparison: grouping },
                                        { property: 'MonthToDate', operator: 'instruction', comparison: _datasetIndex === 1 ? 'prev' : 'curr' },
                                    );
                                } else {
                                    searchCriterias.push(
                                        { property: 'Category', operator: 'eq', comparison: grouping },
                                        { property: 'YearToDate', operator: 'instruction', comparison: _datasetIndex === 1 ? 'prev' : 'curr'  },
                                    );
                                }
                                props.getSelectedItem(
                                    searchCriterias,
                                    true,
                                    `New Leads by Category for ${item} ${GetDateRangeSelectiondLabel(state.options)}`,
                                    DrillDownType.matterSummaryDrilldown,
                                    'New Matter Details',
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    true,
                                );
                            }
                        }}
                        data={{
                            labels: state.groupedBy.length > 0 ? state.groupedBy : [''],
                            datasets: [
                                {
                                    label: 'This Period',
                                    ...rvBarDatasetStyle(RV_CHART_COLORS.primary),
                                    data: state.lastCount,
                                },
                                {
                                    label: 'Previous Period',
                                    ...rvBarDatasetStyle(RV_CHART_COLORS.primarySoft),
                                    data: state.previousCount,
                                },
                            ],
                        }}
                        options={{
                            onHover: onHover,
                            indexAxis: 'y' as const,
                            animation: rvChartAnimation(),
                            elements: { bar: { borderWidth: 0 } },
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                                x: {
                                    grid: rvValueAxisStyle.grid,
                                    // beginAtZero: true,
                                    suggestedMax: getMaxSuggestedTick(
                                        getHighestNumberInArray([...state.previousCount, ...state.lastCount]),
                                        6,
                                    ),
                                    beginAtZero: true,
                                    ticks: {
                                        ...rvValueAxisStyle.ticks,
                                        autoSkip: false,
                                        callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                            return `${formatNumber(tickValue)}`;
                                        },
                                    },
                                },
                                y: {
                                    grid: rvCategoryAxisStyle.grid,
                                    // min: 0,
                                    // max: 9 // minimum display
                                    ticks: {
                                        ...rvCategoryAxisStyle.ticks,
                                        autoSkip: false
                                    }
                                }
                            },
                            plugins: {
                                legend: {
                                    position: 'bottom' as const,
                                    display: true,
                                    labels: rvLegendLabels,
                                },
                                title: {
                                    display: false,
                                    text: ``,
                                },
                                zoom: {
                                    pan: {
                                        enabled: false, // props.showAllRecords,
                                        onPan: onPan,
                                    },
                                    zoom: {
                                        wheel: {
                                            enabled: props.showAllRecords,
                                        },
                                        onZoom: onZoom,
                                    },
                                    // limits: {
                                    //   y: { min: 0, max: 9 },
                                    // },
                                },
                                tooltip: {
                                    ...rvTooltipStyle,
                                    callbacks: {
                                        // tslint:disable-next-line: no-any
                                        label: function (context: any) {
                                            const {
                                                //   label,
                                                formattedValue,
                                                dataset,
                                            } = context;

                                            var currentValue = convertStringNumberToNumber(formattedValue);

                                            var tooltips = [`${dataset.label}: ${currentValue}`];
                                            return tooltips;
                                        },
                                        // tslint:disable-next-line: no-any no-shadowed-variable
                                        afterLabel: function (context: any) {
                                            const {
                                                dataIndex,
                                                //   label,
                                                dataset,
                                            } = context;
                                            var estimateString = '';
                                            if (dataset.label.toLowerCase() === 'this period') {
                                                const currentEstimate = state.lastEstimate[dataIndex];

                                                if (currentEstimate && currentEstimate !== 0) {
                                                    estimateString = `Estimated Fees ${state.symbol}${formatNumber(currentEstimate)}`;
                                                }
                                            } else {
                                                const currentEstimate = state.previousEstimate[dataIndex];

                                                if (currentEstimate && currentEstimate !== 0) {
                                                    estimateString = `Estimated Fees ${state.symbol}${formatNumber(currentEstimate)}`;
                                                }
                                            }
                                            return [
                                                `${estimateString}`
                                            ];
                                        },
                                    },
                                },
                            },
                        }}
                    />
                    {isChartDataEmpty(state.lastCount, state.previousCount) && (
                        <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                    )}
                </div>
                <FormControl component="div">
                    <RadioGroup name="last" value={state.options} onChange={onChangeRadio} className={classes.radioGroup}>
                        <FormControlLabel 
                            value={DateRangeSelectionEnum.LAST_7_DAYS} 
                            control={<Radio color="primary" />} 
                            label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.LAST_7_DAYS)} 
                        />
                        <FormControlLabel
                            value={DateRangeSelectionEnum.LAST_30_DAYS}
                            control={<Radio color="primary" />}
                            label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.LAST_30_DAYS)}
                        />
                        <FormControlLabel
                            value={DateRangeSelectionEnum.LAST_90_DAYS}
                            control={<Radio color="primary" />}
                            label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.LAST_90_DAYS)}
                        />
                        <FormControlLabel
                            value={DateRangeSelectionEnum.LAST_12_MONTHS}
                            control={<Radio color="primary" />}
                            label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.LAST_12_MONTHS)}
                        />
                        <FormControlLabel
                            value={DateRangeSelectionEnum.MONTH_TO_DATE}
                            control={<Radio color="primary" />}
                            label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.MONTH_TO_DATE)}
                        />
                        <FormControlLabel
                            value={DateRangeSelectionEnum.PREV_MONTH}
                            control={<Radio color="primary" />}
                            label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.PREV_MONTH)}
                        />
                        <FormControlLabel
                            value={DateRangeSelectionEnum.YEAR_TO_DATE}
                            control={<Radio color="primary" />}
                            label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.YEAR_TO_DATE)}
                        />
                    </RadioGroup>
                    {/* <FooterDescription>
                        {state.symbol}
                        {formatNumber(state.matterOpenEstimate)} total estimated fees,
                        <br />
                        {formatNumber(state.matterOpenWithoutEstimate)} matters without estimates 
                        <br />
                        {state.symbol}
                        {formatNumber(state.prevmatterOpenEstimate)} total estimated fees, <br />
                        {formatNumber(state.prevmatterOpenWithoutEstimate)} previous matters without estimates
                    </FooterDescription> */}
                    {state.groupedByCountValue > 10 && (
                        <ChartLimitNote>The top 10 Categories are shown</ChartLimitNote>
                    )}
                </FormControl>
                {/* <span className={classes.span}>{formatNumber(state.openEnquiryCount)} open enquiries have no Fee Estimate</span> */}
                {/* <span className={classes.span}>Drill down to timekeeper details</span>     
                <span className={classes.span}>The top 10 timekeepers are shown</span>                           */}
            </div>
        </>
    );
};

// tslint:disable-next-line:no-any
export interface CurrencySymbolData {
    options: Options;
}

export interface Options {
    currencySymbol: CurrencySymbol;
}

export interface CurrencySymbol {
    symbol: string;
}

export const CURRENCY_SYMBOL_QUERY = gql`
    query CurrencySymbol {
        options {
            currencySymbol {
                symbol
            }
        }
    }
`;

interface CombineNewLeadsDataVariables {
    entityType?: number;
    entityGuid?: string;
    responsibility?: number;
}

interface CombinedNewLeadsData {
    statistics: Statistics;
}

interface Statistics {
    matter: Matter;
}

interface Matter {
    combinedNewMatterLeadsByCategory: CombinedNewMatterLeadsByCategory;
}

interface CombinedNewMatterLeadsByCategory {
    combinedNewMatterLeadsByCategoryLast7Days:     CombinedNewMatterLeadsByCategoryLast12MonthsClass;
    combinedNewMatterLeadsByCategoryLast30Days:    CombinedNewMatterLeadsByCategoryLast12MonthsClass;
    combinedNewMatterLeadsByCategoryLast90Days:    CombinedNewMatterLeadsByCategoryLast12MonthsClass;
    combinedNewMatterLeadsByCategoryLast12Months:  CombinedNewMatterLeadsByCategoryLast12MonthsClass;
    combinedNewMatterLeadsByCategoryPreviousMonth: CombinedNewMatterLeadsByCategoryLast12MonthsClass;
    combinedNewMatterLeadsByCategoryMonthToDate:   CombinedNewMatterLeadsByCategoryLast12MonthsClass;
    combinedNewMatterLeadsByCategoryYearToDate:    CombinedNewMatterLeadsByCategoryLast12MonthsClass;
}

interface CombinedNewMatterLeadsByCategoryLast12MonthsClass {
    matterLeadsOpenedCountTotal:             MatterLeadsOpenedCountTotal;
    previousYearMatterLeadsOpenedCountTotal: MatterLeadsOpenedCountTotal;
    combinedNewMatterLeads:                  CombinedNewMatterLead[];
    groupedByCount:                          number;
}

interface CombinedNewMatterLead {
    groupedBy:        string;
    lastCount:        number;
    lastEstimate:     number;
    previousCount:    number;
    previousEstimate: number;
}

interface MatterLeadsOpenedCountTotal {
    count:                  number;
    mattersWithoutEstimate: number;
    totalEstimates:         number;
}

const COMBINED_NEW_LEADS_DATA = gql`
    fragment CombinedNewMatterLeadsByPeriodFragment on CombinedNewMatterLeadsByPeriod {
            matterLeadsOpenedCountTotal {
                count
                mattersWithoutEstimate
                totalEstimates
            }
            previousYearMatterLeadsOpenedCountTotal {
                count
                mattersWithoutEstimate
                totalEstimates
            }
            combinedNewMatterLeads {
                groupedBy
                lastCount
                lastEstimate
                previousCount
                previousEstimate
            }
            groupedByCount
        }
        query combinedNewMatterLeadsdata($entityType: Int, $entityGuid: String, $responsibility: Int) {
            statistics {
                matter {
                    combinedNewMatterLeadsByCategory(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility) {
                        combinedNewMatterLeadsByCategoryLast7Days {
                            ...CombinedNewMatterLeadsByPeriodFragment
                        }
                        combinedNewMatterLeadsByCategoryLast30Days {
                            ...CombinedNewMatterLeadsByPeriodFragment
                        }
                        combinedNewMatterLeadsByCategoryLast90Days {
                            ...CombinedNewMatterLeadsByPeriodFragment
                        }
                        combinedNewMatterLeadsByCategoryLast12Months {
                            ...CombinedNewMatterLeadsByPeriodFragment
                        }
                        combinedNewMatterLeadsByCategoryPreviousMonth {
                            ...CombinedNewMatterLeadsByPeriodFragment
                        }
                        combinedNewMatterLeadsByCategoryMonthToDate {
                            ...CombinedNewMatterLeadsByPeriodFragment
                        }
                        combinedNewMatterLeadsByCategoryYearToDate {
                            ...CombinedNewMatterLeadsByPeriodFragment
                        }
                    }
                }
            }
        }
`;
